module.exports = __webpack_public_path__ + "img/archi2.fbb91227.png";